import React from "react";

export const GameModeModal = ({
                                  gameThumbnail,
                                  handleJoinPlayWithStranger,
                                  isCreatePWSRoomButtonLoading,
                                  mode
                              }) => {


    return (
        <div
            className={`h-[100dvh] left-0 flex flex-col relative ${mode === "dark" ? "bg-black" : "bg-white"} transform transition-all duration-200 ease-out w-full items-center justify-center rounded-none overflow-hidden`}
        >
            <div className="absolute inset-0">
                <img
                    draggable="false"
                    src={gameThumbnail}
                    alt="Background"
                    className="w-full h-[20%] object-cover opacity-90"
                    style={{
                        filter: "blur(10px)",
                    }}
                />
            </div>
            <div
                style={{width: "fit-content", borderRadius: "10px"}}
                className="multiplayer-modal-wrapper relative"
            >
                <div
                    className=" flex flex-col gap-6 justify-center items-center pb-14 pt-2 md-lg:translate-y-5 lg:-translate-y-6 ">
                    <div className="h-36 w-36 border-[10px] border-[#282828] rounded-[15px]">
                        <img
                            draggable={false}
                            src={gameThumbnail}
                            alt="game-logo-icon"
                            className="h-full w-full object-cover rounded-[5px]"
                        />
                    </div>

                    <div className="gap-4 space-y-2">
                        <button
                            onClick={() => {
                                if (isCreatePWSRoomButtonLoading) {
                                    return;
                                }
                                handleJoinPlayWithStranger()
                            }}
                            className="w-full bg-[#FFE354] text-[#313232] py-2 md:py-3 rounded-xl font-semibold flex items-center justify-center focus:outline-none"
                            style={{minWidth: "300px"}}
                            disabled={isCreatePWSRoomButtonLoading}
                        >
                            <div className="flex relative items-center space-x-2">
                                {isCreatePWSRoomButtonLoading ? (
                                    <span className="loader"></span>
                                ) : (
                                    <>
                                        <img
                                            draggable={false}
                                            src="/images/pws_icon.png"
                                            alt="Create Room"
                                            className="w-6 h-6"
                                        />
                                        <span className="font-satoshi font-semibold md:text-xl">
                      Play With Strangers
                    </span>
                                    </>
                                )}
                            </div>
                        </button>
                    </div>

                </div>
            </div>
            <img
                src={"/images/multiplayer_bottom.png"}
                className={"absolute w-[100dvw] max-h-[200px] bottom-0 block md:hidden"}
            />
        </div>
    );
};
